document.addEventListener('DOMContentLoaded', function () {
      var accordions = document.querySelectorAll('.footer-block__accordion');
        var isDesktop = window.matchMedia('(min-width: 750px)').matches;

          accordions.forEach(function (el) {
              el.open = isDesktop;
                });
                });